<template>
  <div>
    <div align="left"></div>
    <br />
    <div class="text-left">
      <h5 class="font-weight-bold text-primary">Layanan Kami</h5>
      <b-row class="mt-4">
        <b-col md="4" class="my-1">
          <b-form-group class="mb-0">
            <b-input-group>
              <b-form-input v-model="filter" placeholder="Search"></b-form-input>
              <b-input-group-append>
                <b-button variant="primary" :disabled="!filter" @click="filter = ''">Clear</b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col md="2" class="my-1" align="right">
          <b-form-group label-cols-sm="6" label="Show" class="mb-0">
            <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
          </b-form-group>
        </b-col>
        <b-col md="3" class="my-1"></b-col>
        <b-col md="3" class="my-1" align="right">
          <router-link :to="{name: 'createOurService'}">
            <b-button variant="primary">
              <img src="@/assets/create-new.svg" class="mr-2" alt />Create New
            </b-button>
          </router-link>
        </b-col>
      </b-row>
      <b-row>
        <br />
      </b-row>
      <section v-if="errored">
        <p>We're sorry, we're not able to retrieve this information at the moment, please try back later</p>
      </section>
      <!-- Main table element -->
      <b-table
        v-else
        responsive
        show-empty
        hover
        :busy="loading"
        :items="items"
        :fields="key"
        :current-page="currentPage"
        :per-page="perPage"
        :filter="filter"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :sort-direction="sortDirection"
        @filtered="onFiltered"
        head-variant="light"
        class="bg-white"
      >
        <div slot="table-busy" class="text-center text-primary my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong>Loading...</strong>
        </div>
        <template v-slot:cell(content.id)="row">
          <div v-html="row.value.substring(0,50)"></div>
        </template>
        <template v-slot:cell(image_jpg)="row">
          <b-img :src="row.value" width="75px" rounded alt="Image"></b-img>
        </template>
        <template v-slot:cell(icon)="row">
          <b-img :src="row.value" width="75px" rounded alt="Image"></b-img>
        </template>
        <template v-slot:cell(created_at_date_only)="{ value, item }">
          <p class="mb-0">{{item.created_at_date_only}}</p>
          by {{item.created_by_username}}
        </template>
        <template v-slot:cell(updated_at_date_only)="{ value, item }">
          <div v-if="item.updated_at_date_only == ''">-</div>
          <div v-else>
            <p class="mb-0">{{item.updated_at_date_only}}</p>
            by {{item.updated_by_username}}
          </div>
        </template>
        <template v-slot:cell(action)="{ value, item }">
          <router-link
            v-b-tooltip.hover
            title="Edit"
            :to="{name: 'editOurService', params: {id: item.our_service_id}}"
            class="text-dark"
          >
            <img src="@/assets/ic-edit.svg" class="mr-2" alt />
          </router-link>
          <b-link
            v-b-tooltip.hover
            title="Delete"
            class="text-dark"
            @click="del(item.our_service_id)"
          >
            <img src="@/assets/rectangle.svg" class="mr-2" alt />
          </b-link>
          <b-link
            v-b-tooltip.hover
            title="Up Order"
            :class="{'order-link':item.order_field === 1}"
            @click="orderOurService({id:item.our_service_id,change:'up'})"
            class="text-primary"
          >
            <i class="fas fa-arrow-up mr-2"></i>
          </b-link>
          <b-link
            v-b-tooltip.hover
            title="Down Order"
            :class="{'order-link':item.is_last_order}"
            @click="orderOurService({id:item.our_service_id,change:'down'})"
            class="text-primary"
          >
            <i class="fas fa-arrow-down"></i>
          </b-link>
        </template>
      </b-table>

      <b-row class="mx-auto">
        <b-col md="4" class="mx-auto px-0">Total entries {{rows}}</b-col>
        <b-col md="4" class="mx-auto"></b-col>
        <b-col md="4" align="right" class="px-0">
          <b-pagination
            align="right"
            v-model="currentPage"
            :total-rows="rows"
            :per-page="perPage"
            class="my-0"
          ></b-pagination>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      loading: true,
      errored: false,
      items: [],
      svgImage: [],
      svgIcon: [],
      key: [
        {
          key: "created_at_date_only",
          label: "Created",
          sortable: true,
          class: "text-left"
        },
        {
          key: "title.id",
          label: "Title",
          sortable: true,
          class: "text-center"
        },
        {
          key: "content.id",
          label: "Content",
          sortable: true,
          class: "text-center"
        },
        {
          key: "icon",
          label: "Icon",
          sortable: true,
          class: "text-center"
        },
        {
          key: "image_jpg",
          label: "Image",
          sortable: true,
          class: "text-center"
        },
        {
          key: "order_field",
          label: "Order Field",
          sortable: true,
          class: "text-left"
        },
        {
          key: "updated_at_date_only",
          label: "Updated",
          sortable: true,
          class: "text-left"
        },
        { key: "action", label: "Action", class: "text-center" }
      ],
      totalRows: 1,
      SvgData:
        '<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" width="580" height="380" viewBox="0 0 580 380"><defs><style>.cls-1{fill:#605195;}.cls-1,.cls-3,.cls-4,.cls-6{fill-rule:evenodd;}.cls-2{fill:none;stroke:#605195;stroke-width:3px;}.cls-3{fill:#febb12;}.cls-4,.cls-5{fill:#5f51a1;}.cls-6{fill:#fbb017;}</style></defs><title>ilustrasi-paxelmarket</title><path class="cls-1" d="M2.9,344.3h171c.6,0,1-1.2,1-2.7s-.4-2.7-1-2.7H2.9c-.6,0-1,1.2-1,2.7s.5,2.7,1,2.7"/><path class="cls-2" d="M2.9,344.3h171c.6,0,1-1.2,1-2.7s-.4-2.7-1-2.7H2.9c-.6,0-1,1.2-1,2.7S2.4,344.3,2.9,344.3Z"/><path class="cls-1" d="M68.7,344.3a2.69,2.69,0,0,0,2.7-2.7v-19a2.7,2.7,0,1,0-5.4,0v19a2.82,2.82,0,0,0,2.7,2.7"/><path class="cls-2" d="M68.7,344.3a2.69,2.69,0,0,0,2.7-2.7v-19a2.7,2.7,0,1,0-5.4,0v19a2.82,2.82,0,0,0,2.7,2.7Z"/><path class="cls-1" d="M68.7,344.3a3,3,0,0,0,1.6-.5,2.59,2.59,0,0,0,.5-3.7L57.6,322.7a2.64,2.64,0,0,0-4.2,3.2l13.2,17.4a2.81,2.81,0,0,0,2.1,1"/><path class="cls-2" d="M68.7,344.3a3,3,0,0,0,1.6-.5,2.59,2.59,0,0,0,.5-3.7L57.6,322.7a2.64,2.64,0,0,0-4.2,3.2l13.2,17.4a2.81,2.81,0,0,0,2.1,1Z"/><path class="cls-1" d="M69.1,344.3a2.81,2.81,0,0,0,2.1-1l13.2-17.4a2.64,2.64,0,1,0-4.2-3.2L67,340a2.59,2.59,0,0,0,.5,3.7,2.66,2.66,0,0,0,1.6.6"/><path class="cls-2" d="M69.1,344.3a2.81,2.81,0,0,0,2.1-1l13.2-17.4a2.64,2.64,0,1,0-4.2-3.2L67,340a2.59,2.59,0,0,0,.5,3.7A2.66,2.66,0,0,0,69.1,344.3Z"/><path class="cls-1" d="M41.9,344.3a2.69,2.69,0,0,0,2.7-2.7v-19a2.7,2.7,0,0,0-5.4,0v19a2.82,2.82,0,0,0,2.7,2.7"/><path class="cls-2" d="M41.9,344.3a2.69,2.69,0,0,0,2.7-2.7v-19a2.7,2.7,0,0,0-5.4,0v19A2.82,2.82,0,0,0,41.9,344.3Z"/><path class="cls-1" d="M41.9,344.3a3,3,0,0,0,1.6-.5,2.6,2.6,0,0,0,.5-3.7L30.8,322.7a2.64,2.64,0,0,0-4.2,3.2l13.2,17.4a2.81,2.81,0,0,0,2.1,1"/><path class="cls-2" d="M41.9,344.3a3,3,0,0,0,1.6-.5,2.6,2.6,0,0,0,.5-3.7L30.8,322.7a2.64,2.64,0,0,0-4.2,3.2l13.2,17.4A2.81,2.81,0,0,0,41.9,344.3Z"/><path class="cls-1" d="M42.3,342.5a2.81,2.81,0,0,0,2.1-1l13.2-17.4a2.64,2.64,0,1,0-4.2-3.2L40.2,338.3a2.59,2.59,0,0,0,.5,3.7,2.35,2.35,0,0,0,1.6.5"/><path class="cls-2" d="M42.3,342.5a2.81,2.81,0,0,0,2.1-1l13.2-17.4a2.64,2.64,0,1,0-4.2-3.2L40.2,338.3a2.59,2.59,0,0,0,.5,3.7,2.35,2.35,0,0,0,1.6.5Z"/><path class="cls-3" d="M361.2,203.1H467.3V80.6H361.2Zm-22.9-68a9.2,9.2,0,1,1-9.2-9.2,9.18,9.18,0,0,1,9.2,9.2m227.1,0a9.2,9.2,0,1,1-9.2-9.2,9.18,9.18,0,0,1,9.2,9.2M338.3,273.5a9.2,9.2,0,1,1-9.2-9.2,9.18,9.18,0,0,1,9.2,9.2m116.3,0a9.2,9.2,0,1,1-9.2-9.2,9.18,9.18,0,0,1,9.2,9.2m110.8,0a9.2,9.2,0,1,1-9.2-9.2,9.18,9.18,0,0,1,9.2,9.2"/><path class="cls-4" d="M460.2,339h8.3V29.6h-8.3Z"/><path class="cls-4" d="M235.5,71.6H575V63.3H235.5ZM267,203.1H574.3v-8.3H267Zm58.8-76.8a5.5,5.5,0,1,0,5.5,5.5,5.48,5.48,0,0,0-5.5-5.5m0,15.5a9.9,9.9,0,1,1,9.9-9.9,9.92,9.92,0,0,1-9.9,9.9m116.3-15.5a5.5,5.5,0,1,0,5.5,5.5,5.42,5.42,0,0,0-5.5-5.5m0,15.5a9.9,9.9,0,1,1,9.9-9.9,9.92,9.92,0,0,1-9.9,9.9m110.8-15.5a5.5,5.5,0,1,0,5.5,5.5,5.48,5.48,0,0,0-5.5-5.5m0,15.5a9.9,9.9,0,1,1,9.9-9.9,9.92,9.92,0,0,1-9.9,9.9m-227.1,123a5.5,5.5,0,1,0,5.5,5.5,5.42,5.42,0,0,0-5.5-5.5m0,15.4a9.9,9.9,0,1,1,9.9-9.9,9.8,9.8,0,0,1-9.9,9.9m116.3-15.4a5.5,5.5,0,1,0,5.5,5.5,5.36,5.36,0,0,0-5.5-5.5m0,15.4a9.9,9.9,0,1,1,9.9-9.9,9.8,9.8,0,0,1-9.9,9.9m110.8-15.4a5.5,5.5,0,1,0,5.5,5.5,5.42,5.42,0,0,0-5.5-5.5m0,15.4a9.9,9.9,0,1,1,9.9-9.9,9.8,9.8,0,0,1-9.9,9.9"/><path class="cls-4" d="M230.6,25.5V186.7h8.3V33.7H570.2V334.9H283v8.3H578.5V25.5Z"/><path class="cls-4" d="M254.3,179.1a24.22,24.22,0,0,1-23.5-18,4.5,4.5,0,1,1,8.7-2.3,15.42,15.42,0,0,0,30.3-3.8,14.9,14.9,0,0,0-4.5-10.7,4.45,4.45,0,0,1,6.3-6.3,23.89,23.89,0,0,1,7.1,17.1,24.35,24.35,0,0,1-24.4,24m4.5,162.7a16.51,16.51,0,0,0,8.1,2.4,14.42,14.42,0,0,0,7.7-2.3l-.4-51.7-28.6-39.6a4.35,4.35,0,0,1-.6-4l7.8-25a4.34,4.34,0,0,1,3.4-3,4.59,4.59,0,0,1,4.3,1.5c4.7,5.6,17.1,18.7,32.7,20.7,5.7-2.9,6-8.5,5.8-11.1-5.9-1-24.7-6.6-40.2-37.5H235.6L213,251.7l-.1,39.5a5.37,5.37,0,0,1-.5,2.1l-22,42c1.3,3.5,4.6,8.7,13,8.7h.7l24-48.9.7-28.5a4.47,4.47,0,0,1,3.2-4.2,4.67,4.67,0,0,1,5,1.7l21.1,30.2a4.7,4.7,0,0,1,.8,2.6l-.1,44.9Zm8.1,11.3a24.47,24.47,0,0,1-14.4-4.8l-.9-.7a4.4,4.4,0,0,1-1.7-3.5V298.3l-12.5-17.9-.4,15.8a4.49,4.49,0,0,1-.5,1.9L211,350.2a4.5,4.5,0,0,1-3.7,2.5s-3.1.2-3.9.2c-15.8,0-20.7-12.2-21.8-15.9l-.3-1a4.69,4.69,0,0,1,.3-3.3L204,290l.1-39.2a4.53,4.53,0,0,1,.3-1.6l23.9-63.1a4.56,4.56,0,0,1,4.2-2.9h29.1a4.57,4.57,0,0,1,4,2.5l.6,1.3c15.8,32.4,34.8,34,35,34h1.7a4.59,4.59,0,0,1,4.2,3.4l.4,1.7c1.3,5.8.6,18.2-11.8,23.3a3.86,3.86,0,0,1-2.1.3c-14.9-1.3-27.2-10.8-34.5-18.1l-4.8,15.5L282.4,286a5,5,0,0,1,.8,2.6l.4,55.5a4.55,4.55,0,0,1-1.8,3.6l-1,.7a22.65,22.65,0,0,1-13.9,4.7Z"/><path class="cls-4" d="M235.1,164.4a4.37,4.37,0,0,1-4.3-3.4,25.54,25.54,0,0,1-.8-6.1,24.4,24.4,0,0,1,41.5-17.1,4.45,4.45,0,1,1-6.3,6.3,15.42,15.42,0,0,0-26.3,10.7,17.37,17.37,0,0,0,.5,3.9,4.41,4.41,0,0,1-3.2,5.4,2.28,2.28,0,0,1-1.1.3"/><path class="cls-5" d="M107.3,110.1v-1.9h-6.9V105h6.1v-1.9h-6.1V99.9h6.9V98h-9v12.1Zm4.9.2a3.42,3.42,0,0,0,1.8-.4,6.23,6.23,0,0,0,1.2-.9v1.1h2.1v-5.4a3.56,3.56,0,0,0-1-2.8,4,4,0,0,0-3-1,9.2,9.2,0,0,0-1.9.2,5.23,5.23,0,0,0-1.6.6l.6,1.7a5.64,5.64,0,0,1,1.2-.4,5.9,5.9,0,0,1,1.4-.2,2.86,2.86,0,0,1,1.7.5,1.75,1.75,0,0,1,.6,1.5v.2l-1.1-.3a6.15,6.15,0,0,0-1.4-.1,7.72,7.72,0,0,0-1.5.2,2.73,2.73,0,0,0-1.2.6,3.45,3.45,0,0,0-.8.9,2.77,2.77,0,0,0-.3,1.3h0a2.13,2.13,0,0,0,.3,1.2,2.55,2.55,0,0,0,1.7,1.4,4.87,4.87,0,0,0,1.2.1Zm.6-1.6a2.77,2.77,0,0,1-1.3-.3,1.23,1.23,0,0,1-.5-1h0a1.1,1.1,0,0,1,.6-1,2.41,2.41,0,0,1,1.5-.4,4.87,4.87,0,0,1,1.2.1,4.65,4.65,0,0,1,.9.3v.5a1.88,1.88,0,0,1-.2.8,2.65,2.65,0,0,1-.5.6,2,2,0,0,1-.8.4Zm10.1,1.6a5.07,5.07,0,0,0,1.3-.2,3.7,3.7,0,0,0,1.1-.5,2.18,2.18,0,0,0,.7-.9,2.77,2.77,0,0,0,.3-1.3h0a2,2,0,0,0-.3-1.1,2.34,2.34,0,0,0-.7-.7,4.05,4.05,0,0,0-.9-.5c-.3-.1-.7-.3-1-.4s-.5-.2-.8-.3-.5-.2-.7-.3-.3-.2-.5-.3a.76.76,0,0,1-.2-.4h0a.91.91,0,0,1,.3-.7,1.22,1.22,0,0,1,.9-.3,5,5,0,0,1,1.2.2c.4.2.9.4,1.3.6l.8-1.5a8,8,0,0,0-1.6-.8,5.55,5.55,0,0,0-1.7-.3,5.85,5.85,0,0,0-1.3.2,2.07,2.07,0,0,0-1,.6,2.4,2.4,0,0,0-.9,2.1h0a2,2,0,0,0,.3,1.1,5,5,0,0,0,.7.8,4.05,4.05,0,0,0,.9.5c.3.1.7.2,1,.3a2.35,2.35,0,0,0,.8.2c.2.1.5.2.7.3a1.38,1.38,0,0,1,.4.3.76.76,0,0,1,.2.5h0a.75.75,0,0,1-.4.7,1.49,1.49,0,0,1-1,.3,4,4,0,0,1-1.5-.3,10.93,10.93,0,0,1-1.5-.8l-.9,1.4a5,5,0,0,0,1.9,1,4.3,4.3,0,0,0,2.1.5Zm7.4,2.7a3.08,3.08,0,0,0,1-.1,2,2,0,0,0,.8-.4,5.72,5.72,0,0,0,.7-.8,6.66,6.66,0,0,0,.6-1.2l3.6-9.4h-2.2l-2.4,6.8-2.6-6.8h-2.2l3.8,9.1a1.83,1.83,0,0,1-.6.8.84.84,0,0,1-.7.2,1.27,1.27,0,0,1-.6-.1c-.2-.1-.4-.1-.6-.2l-.7,1.6a4.18,4.18,0,0,0,1,.4,3.42,3.42,0,0,0,1.1.1Zm16.7-2.7a3.08,3.08,0,0,0,1-.1,6.89,6.89,0,0,0,.8-.3v-1.7a2.77,2.77,0,0,1-1.3.3,1,1,0,0,1-.8-.3,1.22,1.22,0,0,1-.3-.9v-4.5h2.5V101h-2.5V98.5h-2.1V101h-1.2v1.8h1.2v4.8a5.07,5.07,0,0,0,.2,1.3,2.1,2.1,0,0,0,1.3,1.3c.4,0,.8.1,1.2.1Zm8.4,0a4.48,4.48,0,0,0,2-.4,5.6,5.6,0,0,0,1.5-1,4,4,0,0,0,1-1.5,5.84,5.84,0,0,0,.4-1.8h0a3.42,3.42,0,0,0-.4-1.8,4.6,4.6,0,0,0-2.5-2.5,5.85,5.85,0,0,0-1.9-.4,3.81,3.81,0,0,0-1.9.4,5.6,5.6,0,0,0-1.5,1,4,4,0,0,0-1,1.5,5.85,5.85,0,0,0-.4,1.9h0a3.66,3.66,0,0,0,.4,1.8,4.6,4.6,0,0,0,2.5,2.5,4.5,4.5,0,0,0,1.8.3Zm0-1.8a3.59,3.59,0,0,1-1.1-.2l-.9-.6-.6-.9a4.25,4.25,0,0,1-.2-1.1h0a3.59,3.59,0,0,1,.2-1.1,2.76,2.76,0,0,1,1.5-1.5,2,2,0,0,1,1.1-.2,3.59,3.59,0,0,1,1.1.2l.9.6.6.9a4.25,4.25,0,0,1,.2,1.1h0a3.59,3.59,0,0,1-.2,1.1,2.76,2.76,0,0,1-1.5,1.5,3.59,3.59,0,0,1-1.1.2Zm15.3,1.8a2.86,2.86,0,0,0,1.7-.5,3.84,3.84,0,0,0,1.1-1.1v1.4h2.1V101h-2.1v5.2a2.35,2.35,0,0,1-.6,1.7,2,2,0,0,1-1.5.6,1.68,1.68,0,0,1-1.4-.6,2.65,2.65,0,0,1-.5-1.7V101h-2.1v5.8a4.24,4.24,0,0,0,.8,2.6,3.66,3.66,0,0,0,2.5.9Zm10.8,0a5.07,5.07,0,0,0,1.3-.2,3.7,3.7,0,0,0,1.1-.5,2.18,2.18,0,0,0,.7-.9,2.77,2.77,0,0,0,.3-1.3h0a2,2,0,0,0-.3-1.1,2.34,2.34,0,0,0-.7-.7,4.05,4.05,0,0,0-.9-.5c-.3-.1-.7-.3-1-.4s-.5-.2-.8-.3-.5-.2-.7-.3-.3-.2-.5-.3a.76.76,0,0,1-.2-.4h0a.91.91,0,0,1,.3-.7,1.22,1.22,0,0,1,.9-.3,5,5,0,0,1,1.2.2c.4.2.9.4,1.3.6l.8-1.5a8,8,0,0,0-1.6-.8,5.55,5.55,0,0,0-1.7-.3,5.07,5.07,0,0,0-1.3.2,2.07,2.07,0,0,0-1,.6,2.18,2.18,0,0,0-.7.9,2.13,2.13,0,0,0-.3,1.2h0a2,2,0,0,0,.3,1.1,2.7,2.7,0,0,0,.7.8,4.05,4.05,0,0,0,.9.5c.3.1.7.2,1,.3a2.35,2.35,0,0,0,.8.2c.2.1.5.2.7.3s.3.2.5.3a.76.76,0,0,1,.2.4h0a.75.75,0,0,1-.4.7,1.49,1.49,0,0,1-1,.3,4,4,0,0,1-1.5-.3,10.93,10.93,0,0,1-1.5-.8l-.9,1.4a6.92,6.92,0,0,0,1.9,1,3.39,3.39,0,0,0,2.1.6Zm9.7,0a5.09,5.09,0,0,0,2.2-.5,6.1,6.1,0,0,0,1.6-1.2l-1.2-1.1a3.83,3.83,0,0,1-1.1.8,2.9,2.9,0,0,1-1.4.3,2.35,2.35,0,0,1-1.7-.6,2.59,2.59,0,0,1-.9-1.7h6.7v-.6a5.82,5.82,0,0,0-.3-1.9,8,8,0,0,0-.8-1.6,4.1,4.1,0,0,0-3.3-1.5,3.42,3.42,0,0,0-1.8.4,4.51,4.51,0,0,0-1.4,1,3.77,3.77,0,0,0-.9,1.5,5.82,5.82,0,0,0-.3,1.9h0a4.06,4.06,0,0,0,.4,1.9,4,4,0,0,0,1,1.5,5.6,5.6,0,0,0,1.5,1,2.86,2.86,0,0,0,1.7.4Zm2-5.4h-4.7a3,3,0,0,1,.8-1.7,2.36,2.36,0,0,1,1.6-.7,2.39,2.39,0,0,1,.9.2,1.79,1.79,0,0,1,.7.5,2.18,2.18,0,0,1,.5.8,2.92,2.92,0,0,1,.2.9Z"/><path class="cls-6" d="M53.7,93.9a6.07,6.07,0,0,0-5.1,2.9,6.07,6.07,0,0,0-5.1-2.9,6.4,6.4,0,0,0-5.7,3.3,5.72,5.72,0,0,0,.6,6c3.6,5.1,9.8,9,9.8,9s.2.1.3.1h0a.37.37,0,0,0,.3-.1,37.91,37.91,0,0,0,9.8-9,5.52,5.52,0,0,0,.6-6,5.87,5.87,0,0,0-5.5-3.3"/><path class="cls-5" d="M74.4,80.3a2.19,2.19,0,0,1,2.2,2v41.8a2.19,2.19,0,0,1-2,2.2h-19a2.22,2.22,0,0,1-2.2-2.2,2.19,2.19,0,0,1,2-2.2H72.1V84.6H25V122h9.2a2.19,2.19,0,0,1,2.2,2v6.7l10.2-8.2a2.29,2.29,0,0,1,3,.2l.1.1a2.29,2.29,0,0,1-.2,3l-.1.1L35.6,137a2.15,2.15,0,0,1-3.5-1.6v-9H22.9a2.19,2.19,0,0,1-2.2-2V82.5a2.19,2.19,0,0,1,2-2.2H74.4Z"/></svg>',
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      sortBy: null,
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      customerShow: false,
      infoModal: {
        id: "info-modal",
        title: "",
        content: ""
      }
    };
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => ({ text: f.label, value: f.key }));
    },
    rows() {
      return this.items.length;
    }
  },
  beforeCreate() {
    this.$store
      .dispatch("OurServiceModule/getOurServices")
      .then(response => {
        this.loading = false;
      })
      .catch(error => {
        this.$swal({
          type: "error",
          title: "Oops...",
          text: error.response.data.message,
          showConfirmButton: false,
          timer: 1500
        });
        this.loading = false;
      });
  },
  created() {
    this.$store.watch(
      state => state.OurServiceModule.our_service,
      (newValue, oldValue) => {
        this.items = newValue;
      }
    );
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.items.length;
  },
  methods: {
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    del(id) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!"
      }).then(result => {
        if (result.value) {
          this.$store.dispatch("OurServiceModule/delOurService", id);
          this.$swal("Deleted!", "Your file has been deleted.", "success");
        }
      });
    },
    orderOurService(order) {
      this.loading = true;
      const orderData = {
        change_type: order.change
      };
      this.$store
        .dispatch("OurServiceModule/orderOurService", {
          id: order.id,
          orderData
        })
        .then(response => {
          this.$store
            .dispatch("OurServiceModule/getOurServices")
            .then(response => {
              this.loading = false;
            })
            .catch(error => {
              this.loading = false;
            });
          this.$swal({
            type: "success",
            title: "Your work has been saved",
            showConfirmButton: false,
            timer: 1500
          });
          console.log(response);
        })
        .catch(error => {
          this.loading = false;
          this.$swal({
            type: "error",
            title: "Oops...",
            text: error.response.data.message,
            showConfirmButton: false,
            timer: 1500
          });
          console.log(error);
        });
    }
  }
};
</script>

<style scoped>
</style>
